import Cookies from 'js-cookie'

const USERNAME_KEY = 'username'
const ADMIN_ID_KEY = 'ADMIN_ID_KEY'
const MOBILE = 'mobile'

export function setUsername (username) {
  Cookies.set(USERNAME_KEY, username)
}

export function getUsername () {
  return Cookies.get(USERNAME_KEY)
}

export function removeUsername () {
  Cookies.remove(USERNAME_KEY)
}

export function setAdminId (adminId) {
  Cookies.set(ADMIN_ID_KEY, adminId)
}

export function getAdminId () {
  return Cookies.get(ADMIN_ID_KEY)
}

export function removeAdminId () {
  Cookies.remove(ADMIN_ID_KEY)
}

export function setMobile (mobile) {
  Cookies.set(MOBILE, mobile)
}

export function getMobile () {
  return Cookies.get(MOBILE)
}

export function removeMobile () {
  Cookies.remove(MOBILE)
}



// WEBPACK FOOTER //
// ./src/store/common/username.js